
import { useState, useEffect } from 'react';
import { Game } from "@/types/game";

interface UseFormResetProps {
  isOpen: boolean;
  isEditMode: boolean;
  currentGame: Game | null;
}

export const useFormReset = ({ isOpen, isEditMode, currentGame }: UseFormResetProps) => {
  const [gameName, setGameName] = useState<string>('');
  const [coverUrl, setCoverUrl] = useState<string>('');
  const [coverFile, setCoverFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  // Track if cover should be removed
  const [shouldRemoveCover, setShouldRemoveCover] = useState<boolean>(false);

  // Reset form state when dialog opens/closes or edit mode changes
  useEffect(() => {
    if (isOpen) {
      // Initialize form with current game data in edit mode
      if (isEditMode && currentGame) {
        console.log(`Initializing form with game: ${currentGame.name}, cover: ${currentGame.cover_url || 'none'}`);
        setGameName(currentGame.name);
        setCoverUrl(currentGame.cover_url || '');
        setPreviewUrl(currentGame.cover_url);
        setCoverFile(null);
        setShouldRemoveCover(false);
      } else {
        // Reset form for create mode
        console.log('Initializing form for new game');
        setGameName('');
        setCoverUrl('');
        setPreviewUrl(null);
        setCoverFile(null);
        setShouldRemoveCover(false);
      }
    }
    // Removemos currentGame das dependências para evitar loops infinitos
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, isEditMode, currentGame?.id]);
  
  // Special handler for preview changes to detect cover removal
  const handlePreviewChange = (url: string | null) => {
    setPreviewUrl(url);
    if (url === null && isEditMode) {
      // Mark that we should remove the cover
      setShouldRemoveCover(true);
    } else {
      setShouldRemoveCover(false);
    }
  };

  return {
    gameName, setGameName,
    coverUrl, setCoverUrl,
    coverFile, setCoverFile,
    previewUrl, setPreviewUrl: handlePreviewChange,
    shouldRemoveCover
  };
};
